// extracted by mini-css-extract-plugin
module.exports = {"description":"src-reactapp-Settings-ProofreaderSettings---description","radios":"src-reactapp-Settings-ProofreaderSettings---radios"};